export const AssetContextType = {
   SERVICE_ATTACHMENTS: "SERVICE_ATTACHMENTS",
   ORGANIZATION_LOGO: "ORGANIZATION_LOGO",
   REUSE_BOARD_PRODUCT_IMAGE: "REUSE_BOARD_PRODUCT_IMAGE",
};
